module.exports = "\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/client-transactions/sent-receive-inr/sent-receive-inr.component.css
// module id = ./src/app/client-transactions/sent-receive-inr/sent-receive-inr.component.css
// module chunks = main